import React from 'react';
import { getCompleteAppLinkPromoConfig } from '../../helpers/promotions';

import css from './Complete.module.scss';

export const buildAppLink = (
  appStore: string,
  promoId: string,
  partner?: string
) => {
  const appStoreLinksByPartner: any = {
    appleAppStore: {
      MSB: 'https://greenlightme.onelink.me/vRh4/ca5a512f',
      MS: 'https://greenlightme.onelink.me/vRh4/1c349f55',
      AMZN: 'https://greenlightme.onelink.me/vRh4/c827fb78',
      WS: 'https://greenlight.onelink.me/Q6La/42f34c41?partner=ws',
      default: 'https://greenlightme.onelink.me/vRh4/abb5a12a'
    },
    googlePlayStore: {
      MSB: 'https://greenlightme.onelink.me/vRh4/7522f092',
      MS: 'https://greenlightme.onelink.me/vRh4/8181151b',
      AMZN: 'https://greenlightme.onelink.me/vRh4/ca4f13df',
      WS: 'https://greenlight.onelink.me/Q6La/c25818be?partner=ws',
      default: 'https://greenlightme.onelink.me/vRh4/b904a8e6'
    },
    amazonAppStore: {
      MSB: 'https://greenlightme.onelink.me/vRh4/d205eb8f',
      MS: 'https://greenlightme.onelink.me/vRh4/fad9b4f',
      AMZN: 'https://greenlightme.onelink.me/vRh4/8b4eee19',
      WS: 'https://greenlight.onelink.me/Q6La/c70b46cf?partner=ws',
      default: 'https://greenlightme.onelink.me/vRh4/6e139e60'
    }
  };

  const promoAppLink = getCompleteAppLinkPromoConfig(promoId, appStore);

  if (promoAppLink) {
    return promoAppLink;
  }

  return partner
    ? appStoreLinksByPartner[appStore][partner]
    : appStoreLinksByPartner[appStore].default;
};
interface Props {
  promoId: string;
  partner: string;
}

const AppDownloadLinks = ({ promoId, partner }: Props) => (
  <div data-e2e="app-link" className={css.appStoreLinks}>
    <a
      href={buildAppLink('appleAppStore', promoId, partner)}
      data-e2e="apple-app-store-link"
      data-testid="apple-app-store-link"
    >
      <img
        src="../../../static/apple-app-store.svg"
        alt="Apple App Store link"
      />
    </a>
    <a
      href={buildAppLink('googlePlayStore', promoId, partner)}
      data-e2e="google-play-store-link"
      data-testid="google-play-store-link"
    >
      <img
        src="../../../static/google-play-store.svg"
        alt="Google Play Store link"
      />
    </a>
    <a
      href={buildAppLink('amazonAppStore', promoId, partner)}
      data-e2e="amazon-app-store-link"
      data-testid="amazon-app-store-link"
    >
      <img
        src="../../../static/amazon-app-store.svg"
        alt="Amazon App Store link"
      />
    </a>
  </div>
);

export default AppDownloadLinks;
